// extracted by mini-css-extract-plugin
export default {"scoreCardWrapper":"ScoreCard_scoreCardWrapper__0L6V3","scoreCardName":"ScoreCard_scoreCardName__N913c","scoreCardScore":"ScoreCard_scoreCardScore__XAMzb"};